export default __webpack_public_path__ + "static/media/airbnbLogo.0ca15a27.png";